
import BasicDetailsActions from "./BasicDetails";
import BillingActions from "./Billing";
import AgreementActions from "./Agreement";
import QuotationActions from "./Quotation";
import TaskActions from "./Task";
import MenuPermissionsActions from "./MenuPermissions";
import ClientTrackingActions from "./ClientTracking";
import SalesTrackingActions from "./SalesTracking";

export const screenTypes = ["view", "create", "update", "delete", "bulk_create"];

export const Actions = {
    ...BasicDetailsActions,
    ...BillingActions,
    ...AgreementActions,
    ...QuotationActions,
    ...TaskActions,
    ...MenuPermissionsActions,
    ...ClientTrackingActions,
    ...SalesTrackingActions,
}
